/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  PurchaseSoftware.tsx
*
* Project Title :  Checkout
*
* Description	: Purchase Software page
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H175591
*
* @Date		    : Oct 1, 2019
*
* @Version      : Version 1.0
*
* By            : H224423
* On            : Oct 10, 2019
* Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes. Added common css file.
******************************************************************************/
import React from 'react';
import Layout from '../Layout/Layout';
import './PurchaseSoftware.css';
import ProductListingLayout from './ProductListingLayout';

/**
 * @author ASDS Team
 * @description Common components for Purchase Software.
 */
function PurchaseSoftware() {
    return (
        <Layout>
            <ProductListingLayout />
        </Layout>
    );
}

export default PurchaseSoftware;